import { render } from "./500.vue?vue&type=template&id=cfcf446c&scoped=true"
const script = {}

import "./500.vue?vue&type=style&index=0&id=cfcf446c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/pescle-rodent/pescle-rodent/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cfcf446c"]])

export default __exports__